import { type TermsConfig, TermsManagementPage } from "@/features/terms";

const GLICO_MEMBERS_TERMS_CONFIG: TermsConfig = {
	type: "glicomembers",
	pageTitle: "Glicoメンバーズ利用規約管理",
	termTitle: "Glicoメンバーズ利用規約",
};

export default function GlicoMembersTermsPage() {
	return <TermsManagementPage config={GLICO_MEMBERS_TERMS_CONFIG} />;
}
